<div class="stripe-form-holder">
    <form>
        <div class="row">
            <div class="col-md-12">
                <label for="card-number">{{ paymentsConfig?.form_inputs?.card_number?.label }}</label>
                <div id="card-number" class="input empty"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label for="card-expiry">{{ paymentsConfig?.form_inputs?.expiry_date?.label }}</label>
                <div id="card-expiry" class="input empty"></div>
            </div>
            <div class="col-md-6">
                <label for="card-cvc">{{ paymentsConfig?.form_inputs?.cvv?.label }}</label>
                <div id="card-cvc" class="input empty"></div>
            </div>
        </div>
        <div id="card-errors" role="alert"></div>
    </form>
</div>
